import {
  put,
  call,
  takeLatest,
} from 'redux-saga/effects';

import {
  SHOW_EXPIRED_NOTIFICATION,
} from '../actions/types/NotificationActionTypes';
import {
  logoutAction,
} from '../../../redux/actions/authActions';

function* logoutWorker(action) {
  yield call(action.history.replace, '/');
  yield put(logoutAction());
}

function* notificationWatcher() {
  yield takeLatest(SHOW_EXPIRED_NOTIFICATION, logoutWorker);
}
export default notificationWatcher;
export { logoutWorker };
